<ng-container>
    <!-- Direct Link -->
    @if (item.routerLink && !item.items && item.visible !== false) {
    <a (click)="itemClick($event)" [ngClass]="item.styleClass" [routerLink]="item.routerLink"
        [class.layout-menuitem-direct]="isDirectItem" [class.layout-menuitem-child]="isChildItem"
        routerLinkActive="active-route"
        [routerLinkActiveOptions]="item.routerLinkActiveOptions || { paths: 'exact', queryParams: 'subset', matrixParams: 'ignored', fragment: 'ignored' }"
        [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment" [skipLocationChange]="item.skipLocationChange"
        [replaceUrl]="item.replaceUrl" [state]="item.state" [queryParams]="item.queryParams" [attr.target]="item.target"
        tabindex="0" pRipple>
        @if (getIconPath()) {
        <svg-icon [src]="getIconPath()!" svgClass="w-5 h-5 text-headingText"></svg-icon>
        }
        <span class="layout-menuitem-text">{{ item.label }}</span>
        @if (item.badge) {
        <span class="layout-menuitem-badge">{{ item.badge }}</span>
        }
        @if (item.items) {
        <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
        }
    </a>
    }
    <!-- Submenu -->
    @if ((!item.routerLink || item.items || isBoxSubmenu) && item.visible !== false) {
    <a [attr.href]="item.url" (click)="itemClick($event)" [ngClass]="item.styleClass" [attr.target]="item.target"
        [class.layout-menuitem-parent]="hasActiveChild()" tabindex="0" pRipple>
        @if (getIconPath()) {
        <svg-icon [src]="getIconPath()!" svgClass="layout-menuitem-icon"></svg-icon>
        }
        <span class="layout-menuitem-text">{{ item.label }}</span>
        @if (item.badge) {
        <span class="layout-menuitem-badge">{{ item.badge }}</span>
        }
        @if (item.items || isBoxSubmenu) {
        <svg-icon src="/icons/arrow-down.svg"
            svgClass="w-5 h-5 shrink-0 text-headingText layout-submenu-toggler"></svg-icon>
        }
    </a>
    }
    <!-- Box Submenu -->
    @if (isBoxSubmenu && boxSections && item.visible !== false) {
    <!-- Box Submenu Content -->
    <div [@children]="submenuAnimation" class="box-submenu-container"  [class.hidden]="!active" [class.flex]="active">
        @for (boxSection of boxSections; track $index) {
        <div class="box-submenu-section" [class.box-submenu-section-active]="isBoxSectionActive(boxSection)">
            <!-- Box Header (accordion toggle) -->
            <button
                type="button"
                class="box-submenu-header cursor-pointer "
                [class.box-submenu-header-expanded]="isBoxSectionExpanded($index)"
                (click)="toggleBoxSection($index, $event)"
                [attr.aria-expanded]="isBoxSectionExpanded($index)"
            >
                <div class="box-submenu-header-content">
                    @if (boxSection.icon) {
                    <svg-icon [src]="boxSection.icon" svgClass="box-submenu-header-icon w-5 h-5 shrink-0"></svg-icon>
                    }
                    <span class="box-submenu-header-title text-left">{{ boxSection.title }}</span>
                    @if (boxSection.badge) {
                    <span class="layout-menuitem-badge box-submenu-header-badge">{{ boxSection.badge }}</span>
                    }
                    <svg-icon src="/icons/arrow-down.svg"
                        svgClass="w-5 h-5 shrink-0 text-headingText layout-submenu-toggler box-submenu-header-chevron"></svg-icon>
                </div>
            </button>
            <!-- Box Items -->
            @if (isBoxSectionExpanded($index)) {
            <ul class="box-submenu-items">
                @for (boxItem of boxSection.items; track boxItem.label) {
                <li class="box-submenu-item" [class]="boxItem['badgeClass']">
                    @if (boxItem.routerLink && !boxItem.items?.length) {
                    <a
                        [routerLink]="boxItem.routerLink"
                        [queryParams]="boxItem.queryParams"
                        routerLinkActive="active-route"
                        [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'subset', matrixParams: 'ignored', fragment: 'ignored' }"
                        class="box-submenu-item-link flex items-center justify-between"
                    >
                        <span>{{ boxItem.label }}</span>
                        @if (boxItem.badge) {
                        <span class="layout-menuitem-badge box-submenu-item-badge">{{ boxItem.badge }}</span>
                        }
                    </a>
                    } @else {
                    <button
                        type="button"
                        class="box-submenu-item-link w-full flex items-center justify-between cursor-pointer"
                        (click)="toggleBoxItem($index, $event)"
                        [attr.aria-expanded]="isBoxItemExpanded($index)"
                    >
                        <span>{{ boxItem.label }}</span>
                        <svg-icon
                            src="/icons/arrow-down.svg"
                            svgClass="w-5 h-5 shrink-0 text-headingText layout-submenu-toggler"
                            [class.rotate-180]="isBoxItemExpanded($index)"
                        ></svg-icon>
                    </button>
                    @if (isBoxItemExpanded($index)) {
                    <ul class="box-submenu-items mt-2">
                        @for (subItem of boxItem.items; track subItem.label) {
                        <li class="box-submenu-item ps-2">
                            <a
                                [routerLink]="subItem.routerLink"
                                [queryParams]="subItem.queryParams"
                                routerLinkActive="active-route"
                                [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'subset', matrixParams: 'ignored', fragment: 'ignored' }"
                                class="box-submenu-item-link pl-6"
                            >
                                {{ subItem.label }}
                            </a>
                        </li>
                        }
                    </ul>
                    }
                    }
                </li>
                }
            </ul>
            }
        </div>
        }
    </div>
    } @else if (item.items && item.visible !== false) {
    <ul [@children]="submenuAnimation">
        @for (child of item.items; track $index) {
        @if (isBoxSubmenuForChild(child)) {
        <li app-menuitem [item]="child" [index]="$index" [parentKey]="key" [root]="false"
            [boxSections]="getBoxSectionsForChild(child)" [class]="child['badgeClass']"></li>
        } @else {
        <li app-menuitem [item]="child" [index]="$index" [parentKey]="key" [root]="false" [class]="child['badgeClass']">
        </li>
        }
        }
    </ul>
    }
</ng-container>